import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

const imgPath = "/imgs/kitchen-designs.jpg";
const imgMaster = "/imgs/master-bedroom.jpg";
const imgPooja = "/imgs/pooja-room-designs.jpg";
const imgLiving = "/imgs/living-room-designs.jpg";
const imgKids = "/imgs/kids-bedroom-designs.jpg";
const imgDining = "/imgs/dining-room-designs.jpg";
const imgGuest = "/imgs/guest-bedroom-designs.jpg";

const items = [
  { label: "Modular Kitchen Designs", img: imgPath },
  { label: "Master Bedroom Designs", img: imgMaster },
  { label: "Pooja Room Designs", img: imgPooja },
  { label: "Living Room Designs", img: imgLiving },
  { label: "Kids Bedroom Designs", img: imgKids },
  { label: "Dining Room Designs", img: imgDining },
  { label: "Guest Bedroom Designs", img: imgGuest } 
];

const GalleryGrid = () => (
  <div className="container my-5">
    <div className="row gx-3 gy-3">
      <div className="col-md-6">
        <div className="row gx-3 gy-3">
          <div className="col-12">
            <div className="position-relative rounded-4 overflow-hidden" style={{height:320}}>
              <img src={items[0].img} alt={items[0].label} style={{width:"100%",height:"100%",objectFit:"cover"}} />
              <div className="position-absolute bottom-0 start-0 m-2 px-3 py-1 bg-dark bg-opacity-75 text-white rounded">{items[0].label}</div>
            </div>
          </div>
          <div className="col-6">
            <div className="position-relative rounded-4 overflow-hidden" style={{height:150}}>
              <img src={items[3].img} alt={items[3].label} style={{width:"100%",height:"100%",objectFit:"cover"}} />
              <div className="position-absolute bottom-0 start-0 m-2 px-3 py-1 bg-dark bg-opacity-75 text-white rounded">{items[3].label}</div>
            </div>
          </div>
          <div className="col-6">
            <div className="position-relative rounded-4 overflow-hidden" style={{height:150}}>
              <img src={items[4].img} alt={items[4].label} style={{width:"100%",height:"100%",objectFit:"cover"}} />
              <div className="position-absolute bottom-0 start-0 m-2 px-3 py-1 bg-dark bg-opacity-75 text-white rounded">{items[4].label}</div>
            </div>
          </div>
          {/* <div className="col-6">
            <div className="position-relative rounded-4 overflow-hidden" style={{height:150}}>
              <img src={items[4].img} alt={items[4].label} style={{width:"100%",height:"100%",objectFit:"cover"}} />
              <div className="position-absolute bottom-0 start-0 m-2 px-3 py-1 bg-dark bg-opacity-75 text-white rounded">{items[4].label}</div>
            </div>
          </div> */}
          {/* <div className="col-6">
            <div className="position-relative rounded-4 overflow-hidden" style={{height:150}}>
              <img src={items[4].img} alt={items[4].label} style={{width:"100%",height:"100%",objectFit:"cover"}} />
              <div className="position-absolute bottom-0 start-0 m-2 px-3 py-1 bg-dark bg-opacity-75 text-white rounded">{items[4].label}</div>
            </div>
          </div> */}

        </div>
      </div>
      
      <div className="col-md-3">
        <div className="d-flex flex-column h-100" style={{gap: "12px"}}>
          <div className="position-relative rounded-4 overflow-hidden" style={{height:155}}>
            <img src={items[1].img} alt={items[1].label} style={{width:"100%",height:"100%",objectFit:"cover"}} />
            <div className="position-absolute bottom-0 start-0 m-2 px-3 py-1 bg-dark bg-opacity-75 text-white rounded">{items[1].label}</div>
          </div>

          <div className="position-relative rounded-4 overflow-hidden" style={{height:155}}>
            <img src={items[2].img} alt={items[2].label} style={{width:"100%",height:"100%",objectFit:"cover"}} />
            <div className="position-absolute bottom-0 start-0 m-2 px-3 py-1 bg-dark bg-opacity-75 text-white rounded">{items[2].label}</div>
          </div>
          
          <div className="position-relative rounded-4 overflow-hidden" style={{height:155}}>
            <img src={items[6].img} alt={items[6].label} style={{width:"100%",height:"100%",objectFit:"cover"}} />
            <div className="position-absolute bottom-0 start-0 m-2 px-3 py-1 bg-dark bg-opacity-75 text-white rounded">{items[6].label}</div>
          </div>
          {/* <div className="position-relative rounded-4 overflow-hidden" style={{height:155}}>
            <img src={items[6].img} alt={items[6].label} style={{width:"100%",height:"100%",objectFit:"cover"}} />
            <div className="position-absolute bottom-0 start-0 m-2 px-3 py-1 bg-dark bg-opacity-75 text-white rounded">{items[6].label}</div>
          </div> */}


        </div>
      </div>

      <div className="col-md-3">
        <div className="position-relative rounded-4 overflow-hidden h-100" style={{height:495}}>
          <img src={items[5].img} alt={items[5].label} style={{width:"100%",height:"100%",objectFit:"cover"}} />
          <div className="position-absolute bottom-0 start-0 m-2 px-3 py-1 bg-dark bg-opacity-75 text-white rounded">{items[5].label}</div>
        </div>
      </div>
    </div>
  </div>
);

export default GalleryGrid;